// UI strings for the top of Tänään in three measures ("Kolme mittaa", Axel's choice 2026-10-06:
// course/TodayTop.tsx): the course row (the open lesson, the next unlock, Halloween 2027), the
// week row with its step ribbon, and today's pair (you and your partner, never compared). The
// next unlock and the goal's status reuse the course area (course.ts) and `frontier`.
// Finnish (default) and English side by side; en has the same shape.
// Style: docs/FINNISH-STYLE.md (te-muoto for both, sinä-muoto for you, no internal jargon).
import { defineArea } from '../area';

export const todayTopFi = {
  /** The course row, its lead in bold: "**Oppitunti 6** avoinna teille molemmille". */
  lesson: (n: number) => `Oppitunti ${n}`,
  openForBoth: 'avoinna teille molemmille',
  /** Screen readers: the three rows. */
  course: 'Kurssi',
  today: 'Tänään',
  /** Today's pair: the label over each count. */
  you: 'Sinä',
  count: (n: number) => `${n} tänään`,
  notYet: 'ei vielä tänään',
  /** The week row's accessible name: "Viikko 1 · Äänteet ja paino · 2/5 tehty · seuraavaksi Tunti". */
  weekRow: (title: string, done: number, total: number, next: string | null) =>
    `${title} · ${done}/${total} tehty · ${next ? `seuraavaksi ${next}` : 'kaikki tehty'}`,
};

export const todayTopEn: typeof todayTopFi = {
  lesson: (n) => `Lesson ${n}`,
  openForBoth: 'open for you both',
  course: 'Course',
  today: 'Today',
  you: 'You',
  count: (n) => `${n} today`,
  notYet: 'not yet today',
  weekRow: (title, done, total, next) => `${title} · ${done}/${total} done · ${next ? `next: ${next}` : 'all done'}`,
};

// Messages.todayTop (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('todayTop', todayTopFi, todayTopEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof todayTopFi> {}
}
